<template>
	<div>
		<div class="mb-4">
			<h1 class="section-title mb-2">Mis favoritos</h1>
			<p class="section-lead mb-0">Abogados y firmas que has marcado como favoritos</p>
		</div>

		<div class="row">
			<div
				v-for="fav in favorites"
				:key="fav.id"
				class="col-md-6 mb-4"
			>
				<div class="favorite-card">
					<div class="favorite-banner" :class="'banner-' + fav.id">
						<div class="favorite-avatar">
							<img :src="fav.image" :alt="fav.name" />
						</div>
					</div>

					<div class="favorite-body text-center">
						<h3 class="favorite-name">{{ fav.name }}</h3>
						<p class="favorite-specialty">{{ fav.specialty }}</p>
						<p class="favorite-bio">{{ fav.bio }}</p>

						<div class="favorite-meta d-flex justify-content-center align-items-center mb-3">
							<span class="mr-3">
								<i class="fa-solid fa-star star-icon"></i>
								<strong>{{ fav.rating }}</strong>
							</span>
							<span class="text-muted">{{ fav.experience }}</span>
						</div>

						<div class="favorite-contact mb-3">
							<p class="mb-1">
								<i class="fa-regular fa-phone mr-1 text-muted"></i>
								{{ fav.phone }}
							</p>
							<p class="mb-0">
								<i class="fa-regular fa-envelope mr-1 text-muted"></i>
								{{ fav.email }}
							</p>
						</div>

						<div class="favorite-notes border-top pt-3">
							<template v-if="editingNotes === fav.id">
								<b-form-textarea
									v-model="favoriteNotes[fav.id]"
									rows="3"
									placeholder="Agrega tus notas sobre este asesor..."
									class="mb-2"
								></b-form-textarea>
								<div class="d-flex">
									<b-button size="sm" variant="info" class="flex-fill mr-2" @click="editingNotes = null">
										Guardar
									</b-button>
									<b-button size="sm" variant="outline-secondary" class="flex-fill" @click="editingNotes = null">
										Cancelar
									</b-button>
								</div>
							</template>
							<template v-else>
								<div class="d-flex align-items-center justify-content-between mb-2">
									<h4 class="notes-title mb-0">Mis notas</h4>
									<button type="button" class="btn-icon" @click="editingNotes = fav.id">
										<i class="fa-regular fa-pen-to-square"></i>
									</button>
								</div>
								<p v-if="favoriteNotes[fav.id]" class="notes-text text-left mb-0">
									{{ favoriteNotes[fav.id] }}
								</p>
								<template v-else>
									<p v-if="fav.id === 1" class="text-muted font-italic small mb-0">Sin notas aún</p>
									<b-button
										v-else
										size="sm"
										variant="outline-secondary"
										block
										@click="editingNotes = fav.id"
									>
										Agregar nota
									</b-button>
								</template>
							</template>
						</div>

						<div class="d-flex mt-3">
							<b-button
								:to="'/directorio/' + fav.id"
								size="sm"
								variant="outline-secondary"
								class="flex-fill mr-2"
							>
								Ver perfil
							</b-button>
							<button type="button" class="btn-icon heart-active">
								<i class="fa-solid fa-heart"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MyAccountFavoritos',

	data() {
		return {
			editingNotes: null,
			favoriteNotes: {
				1: 'Excelente abogada, muy profesional y dedicada. Resolvió mi caso rápidamente.',
				2: '',
			},
			favorites: [
				{
					id: 1,
					name: 'María Elena González',
					specialty: 'Derecho Civil',
					bio: 'Especialista en derecho civil con más de 15 años de experiencia en contratos, propiedad y sucesiones. Enfoque personalizado y resultados comprobados.',
					rating: '4.9',
					experience: '15 años exp.',
					phone: '55-1234-5678',
					email: 'maria.gonzalez@legal.com',
					image: 'public/images/pages/directory/professional-woman-lawyer.png',
				},
				{
					id: 2,
					name: 'Martínez & Asociados',
					specialty: 'Derecho Laboral',
					bio: 'Despacho especializado en derecho laboral y seguridad social. Más de 20 años defendiendo los derechos de trabajadores y empresas.',
					rating: '4.8',
					experience: '20 años exp.',
					phone: '55-9876-5432',
					email: 'contacto@martinezlegal.com',
					image: 'public/images/pages/directory/lawyer-consultation.png',
				},
			],
		}
	},
}
</script>
